/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Iframe_Remote_Style_Guide_Updated_ToastInputs */



/**
* | output |
* | --- |
* | "Style guide \"{name}\" updated successfully" |
*
* @param {Iframe_Remote_Style_Guide_Updated_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_style_guide_updated_toast = /** @type {((inputs: Iframe_Remote_Style_Guide_Updated_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Style_Guide_Updated_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Guide de style "${i?.name}" mis a jour avec succes`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Styleguide "${i?.name}" erfolgreich aktualisiert`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Guida di stile "${i?.name}" aggiornata con successo`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Руководство по стилю "${i?.name}" успешно обновлено`)
	if (locale === "es") return /** @type {LocalizedString} */ (`La guía de estilo "${i?.name}" se actualizó correctamente`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`样式指南“${i?.name}”已成功更新`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`スタイルガイド「${i?.name}」が正常に更新されました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`स्टाइल गाइड "${i?.name}" सफलतापूर्वक अपडेट हो गई`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Guia de estilo "${i?.name}" atualizado com sucesso`)
	return /** @type {LocalizedString} */ (`Style guide "${i?.name}" updated successfully`)
});